// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "container-SdX0k";
var _3 = "container_active-3aZ2d";
var _4 = "cover-1tc8w";
var _5 = "image-mGp8F";
var _6 = "content-2k1Hc";
var _7 = "description-1zqKP";
var _8 = "content__services-MrjeC";
var _9 = "header-Hw7NK";
var _a = "add-3oO0F";
var _b = "checked-UCbZ0";
var _c = "checked_removable-5wGa-";
var _d = "discount-1RZ_P";
var _e = "footer-1Ha2G";
var _f = "footer_multiButtons-2OIZK";
var _10 = "footer_hiddenButtons-2r3KB";
var _11 = "total-2gBnA";
var _12 = "totalPrice-34ktG";
var _13 = "buttons-2Wnye";
var _14 = "icons-sbzTX";
var _15 = "button-Nw5fn";
var _16 = "button_add-3VXl1";
export { _1 as "__esModule", _2 as "container", _3 as "container_active", _4 as "cover", _5 as "image", _6 as "content", _7 as "description", _8 as "content__services", _9 as "header", _a as "add", _b as "checked", _c as "checked_removable", _d as "discount", _e as "footer", _f as "footer_multiButtons", _10 as "footer_hiddenButtons", _11 as "total", _12 as "totalPrice", _13 as "buttons", _14 as "icons", _15 as "button", _16 as "button_add" }
export default { "__esModule": _1, "container": _2, "container_active": _3, "cover": _4, "image": _5, "content": _6, "description": _7, "content__services": _8, "header": _9, "add": _a, "checked": _b, "checked_removable": _c, "discount": _d, "footer": _e, "footer_multiButtons": _f, "footer_hiddenButtons": _10, "total": _11, "totalPrice": _12, "buttons": _13, "icons": _14, "button": _15, "button_add": _16 }
